<template>
  <!-- Removed "ref='draggable'" as requested -->
  <div class="stacked-images" :style="`transform:scale(${zoom_level})`">
    <!--Base Image-->
    <v-img :width="Dimensions" :height="Dimensions" id="base-image" :src="BaseImage(product)" v-if="IsBuilding" />

    <!--Featured Image-->
    <v-img :width="Dimensions" :height="Dimensions" id="feat-image" :src="ProductImage(product)" v-else />

    <!--Accessories-->
    <template v-for="(dataset, key) in attachments" :key="dataset.id || key">
      <img class="img-stack animate-fade-in" :style="`z-index:${key};${CustomAccessoryCss(dataset)}`"
        v-if="dataset.filename" :src="DatasetImage(dataset)">
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
// import interact from "interactjs"

const props = defineProps<{
  attachments: any[]
  product: any
}>()

const store = useGlobalsStore()
const {
  zoom_level,
  is_mobile,
  accessories
} = storeToRefs(store)

// const draggable = ref<HTMLElement | null>(null)

const have_accessories = computed(() => {
  return props.attachments.length > 0
})

const has_base_img = computed(() => {
  if (!props.product || props.product.base_image == null) return false
  return props.product.base_image.length > 0
})

const IsBuilding = computed(() => {
  return has_base_img.value && have_accessories.value
})

const Dimensions = computed(() => {
  return is_mobile.value ? 250 : 500
})

function CustomAccessoryCss(dataset: any) {
  let csstxt = ""
  const rules = JSON.parse(dataset.rules || '[]')
  rules.forEach((rule: any) => {
    if (rule.type == 'custom_css') {
      let is_condition_met = 0
      rule.items.forEach((rule_item_id: any) => {
        let find_item = props.attachments.find(ex => ex.id == rule_item_id && ex.selected)
        if (typeof find_item != 'undefined') {
          is_condition_met++
        }
      })
      if (is_condition_met == rule.items.length && rule.items.length > 0) {
        csstxt = rule.css
      }
    }
  })
  return csstxt
}

function BaseImage(prod: any) {
  const url = (import.meta.env.VITE_SERVERAPI_URL || '') + '/storage/uploads/products'
  if (prod?.base_image && prod.base_image.length > 0) {
    return `${url}/base-img/${prod.base_image}`
  } else {
    return `${url}/base-img/_placeholder_.png`
  }
}

function DatasetImage(dataset: any) {
  const url = (import.meta.env.VITE_SERVERAPI_URL || '') + '/storage/uploads/datasets'
  return `${url}/${dataset.filename}`
}

const ProductImage = store.ProductImage

onMounted(() => {
  /* if (draggable.value) {
    interact(draggable.value).draggable({
      listeners: {
        move(event) {
          const target = event.target
          const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
          const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
          target.style.transform = `translate(${x}px, ${y}px)`
          target.style.transition = '0s'
          target.setAttribute('data-x', x)
          target.setAttribute('data-y', y)
        },
      },
    })
  } */
})
</script>

<style scoped>
/* Product Builder */
.stacked-images {
  transform-origin: center;
  transition: transform 0.3s ease;
  width: fit-content;
  height: fit-content;
  margin: auto;
  position: relative;
  user-select: none;
  -webkit-user-drag: none;
  user-drag: none;

  & img.img-stack {
    position: absolute;
    object-fit: contain;
    top: 0;
    left: 0;
  }

  & img {
    width: 100%;
    height: 100%;
  }
}
</style>
